<template>
    <v-card elevation="0" class="mb-40 mb-lg-60">
        <div class="pa-20 pa-md-30 grey-light rounded-lg">
            <filter-row tit="시설명">
                <v-text-field placeholder="검색어를 입력하세요." v-model="query.name" @keydown.enter="emit" hide-details />
            </filter-row>
            <filter-row tit="비용">
                <v-radio-group v-model="query.isFree" row hide-details>
                    <v-radio label="전체" />
                    <v-radio label="무료" />
                    <v-radio label="유료" />
                </v-radio-group>
            </filter-row>

            <v-divider class="my-16 my-lg-30" />

            <div class="d-flex justify-end">
                <v-btn @click="emit" large class="w-80px w-lg-100px" color="grey-4" elevation="0"><span class="white--text">검색</span></v-btn>
            </div>
        </div>
        <!-- <v-card-text>
            <v-row>
                <v-col align-self="center" cols="auto" style="width: 15%">시설명</v-col>
                <v-col> <v-text-field v-model="query.name" @keydown.enter="emit" /> </v-col>
            </v-row>
            <v-row>
                <v-col align-self="center" cols="auto" style="width: 15%">비용</v-col>
                <v-col>
                    <v-radio-group v-model="query.isFree" row>
                        <v-radio label="전체" />
                        <v-radio label="무료" />
                        <v-radio label="유료" />
                    </v-radio-group>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions class="px-4">
            <v-spacer />
            <v-btn text @click="emit"> <v-icon>mdi-magnify</v-icon> 검색하기</v-btn>
        </v-card-actions> -->
    </v-card>
</template>

<script>
import FilterRow from "@/components/client/dumb/filter-row.vue";

export default {
    components: {
        FilterRow,
    },
    data: () => ({
        query: {
            name: null,
            isFree: 0,
        },
    }),
    mounted() {
        this.sync();
    },
    methods: {
        sync() {
            let { name = null, isFree } = this.$route.query;
            if (isFree) isFree = JSON.parse(isFree);
            if (isFree == undefined) isFree = 0;
            else if (isFree == true) isFree = 1;
            else if (isFree == false) isFree = 2;
            this.query = { name, isFree };
        },
        emit() {
            let query = { ...this.query };
            if (query.isFree == 0) delete query.isFree;
            if (query.isFree == 1) query.isFree = true;
            if (query.isFree == 2) query.isFree = false;
            this.$router.push({ query });
        },
    },
};
</script>

<style>
</style>